import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import { Loader } from '@navent-jobs/ui-kit/components/loader'
import Text from '@navent-jobs/ui-kit/components/text'
import { OptionsContainer, LoaderContainer } from './mixins'
import OpcionClickeable from '../../../../../../../../components/opcion-clickeable'
import motivosDenunciaData from '../../data.json'

const Component = ({ onClickOption, data, isLoading }) => {
  const { colors } = useContext<{ colors }>(ThemeContext)

  if (isLoading) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    )
  }

  return (
    <>
      <Text size="md">
        Necesitamos que respondas unas preguntas para que podamos entender mejor cuál es el problema con el aviso.
      </Text>
      <OptionsContainer>
        {data &&
          data.map(m => {
            const motivo = motivosDenunciaData.motivos.find(e => e.id === m.id)
            return (
              motivo && (
                <OpcionClickeable
                  key={`motivo-${m.id}`}
                  onClick={() => onClickOption(m.id)}
                  title={m.descripcion}
                  iconObject={{ name: 'icon-light-caret-right', color: colors.secondary.normal, size: '24' }}
                  texts={motivo.texts}
                />
              )
            )
          })}
      </OptionsContainer>
    </>
  )
}

export default Component
